import {Utilities} from '../utilities/utilities.model';
export class TagItem {

	label: string;
	newLabel: string;
	count: number;
	countNew: number;
	isNewLabel = false;
	type: string;
	uid: string;
	checked: boolean;
	indeterminate: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.label = model.label;
			this.newLabel = model.newLabel;
			this.count = model.count;
			this.countNew = model.countNew;
			this.isNewLabel = model.isNewLabel;
			this.type = model.type;
			this.uid = model.uid;
		}
	}

	public clone(): TagItem {
		const clone = new TagItem();

		clone.label = this.label;
		clone.newLabel = this.newLabel;
		clone.count = this.count;
		clone.countNew = this.countNew;
		clone.isNewLabel = this.isNewLabel;
		clone.type = this.type;
		clone.uid = this.uid;

		return clone;
	}
}

export interface TagItemSettings {
    uid: string;
    label: string;
}
